import { Chip, Tooltip } from "@mui/material"

const STAGES = {
    roleFilter: {
        label: "ignores roles",
        explanation:
            "This override is granted even to users whose role does not include it. Roles are the client's own delegation, so this overrules a decision their admin made.",
    },
    serverDemands: {
        label: "ignores environment gate",
        explanation:
            "This override applies even though the server_demands setting has not enabled the feature on this environment. A real purchase of the product would be stripped here.",
    },
}

/**
 * Marks an override that forces a demand past a removal stage. Deliberately prominent, and
 * always explained on hover — the raw stage name means nothing to anyone who has not read the
 * pipeline, and a bypass is exactly the thing nobody should enable without understanding it.
 */
export function BypassChip({ item }) {
    const [stage] = item
    const { label, explanation } = STAGES[stage] ?? { label: `forces past ${stage}`, explanation: "" }

    return (
        <Tooltip title={explanation} placement="top" arrow>
            <Chip size="small" color="warning" label={label} data-cy={`access-bypass-${stage}`} />
        </Tooltip>
    )
}
